<!-- start: Paginator -->
<div class="d-flex flex-wrap py-2 mr-3 paging">
  <ng-pagination [collectionSize]="paginator.total" [(page)]="paginator.page" [maxSize]="4" [rotate]="true"
    [showCurrentPageReport]="showCurrentPageReport" [showJumpToPageDropdown]="showJumpToPageDropdown"
    [showJumpToPageInput]="showJumpToPageInput" [boundaryLinks]="true" [pageSize]="paginator.pageSize"
    (pageChange)="pageChange($event)"></ng-pagination>
</div>
<!--<div class="d-flex align-items-center py-3">-->
<!--  &lt;!&ndash; begin: loading &ndash;&gt;-->
<!--  <div class="d-flex align-items-center" *ngIf="isLoading">-->
<!--    <div class="me-2 text-muted">{{"PAGINATOR.LOADING"}}...</div>-->
<!--    <div class="spinner spinner-primary mr-10"></div>-->
<!--  </div>-->
<!--  &lt;!&ndash; end: loading &ndash;&gt;-->

<!--  &lt;!&ndash; begin: pageSize &ndash;&gt;-->
<!--  <select class="form-control form-control-sm font-weight-bold mr-4 border-0 bg-light false" style="width: 75px"-->
<!--    [(ngModel)]="paginator.pageSize" (change)="sizeChange()">-->
<!--    <option class="btn" *ngFor="let ps of pageSizes">-->
<!--      {{ ps }}-->
<!--    </option>-->
<!--  </select>-->
<!--  <span class="react-bootstrap-table-pagination-total me-2">&nbsp;{{"PAGINATOR.SHOWING_ROWS"}}-->
<!--    {{ (paginator.page - 1) * paginator.pageSize + 1 }} {{"PAGINATOR.TO"}}&nbsp;{{-->
<!--      paginator.pageSize * (paginator.page) > paginator.total ? paginator.total : paginator.pageSize * (paginator.page)-->
<!--    }}-->
<!--    {{"PAGINATOR.OF"}}&nbsp;{{ paginator.total }}-->
<!--  </span>-->
<!--  &lt;!&ndash; end: pageSize &ndash;&gt;-->
<!--</div>-->
<!-- end: Paginator -->
